import React from "react";
import { Formik, ErrorMessage, Form } from "formik";
import { ButtonDanger } from "../../ui/templates/buttons";

import { FormGroup, FormControl } from "react-bootstrap";
import { Box } from "@material-ui/core";
import { fontStyleBlack } from "../../ui/constants";

class SendEmailForm extends React.Component {
  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  render() {
    const { handleSendInvitation } = this.props;
    return (
      <Formik
        initialValues={{
          email: "",
        }}
        validate={(values) => {
          let errors = {
            email: this.validateEmail(values.email),
          };

          Object.keys(errors).forEach((key) => {
            if (errors[key] === undefined) {
              delete errors[key];
            }
          });
          return errors;
        }}
        onSubmit={(values) => {
          console.log(values, "values");
          handleSendInvitation(values.email);
        }}
      >
        {({ values, handleChange, handleSubmit, handleBlur }) => (
          <Form
            onSubmit={(...args) => {
              return handleSubmit(...args);
            }}
          >
            <div className="row">
              <div className="col-12">
                <Box style={fontStyleBlack}>Invite Team Members</Box>
                <Box mb={1} className="textStyles">
                  Send an email invitation to your racing crew to join the team!
                </Box>
                <Box
                  className="col-12 textFeildMArgin"
                  display={["block", "flex", "flex"]}
                >
                  <Box
                    alignSelf="top"
                    className="col-sm-8 col-md-8 col-lg-4 textFeildMArgin"
                  >
                    <FormGroup>
                      <FormControl
                        placeholder="Email "
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        name="email"
                        type="email"
                        className="form-control"
                        aria-describedby="emailHelp"
                      />
                      <ErrorMessage
                        name="email"
                        className="error-msg"
                        component="div"
                      />
                    </FormGroup>
                  </Box>
                  <Box
                    pt={["0px", "10px", "10px"]}
                    pl={["0", "10px"]}
                    m={0}
                    alignSelf="top"
                    className="col-sm-4 col-md-4 col-lg-4"
                  >
                    <FormGroup>
                      <ButtonDanger
                        type="submit"
                        teamFullWidth
                        text="Send Invitation"
                      />
                    </FormGroup>
                  </Box>
                </Box>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default SendEmailForm;
